export const HEADER_BLOCK_S04 = {
  "blockType": "HEADER",
  "blockDesign": "header_01",
  "styleProps": {
    "background-image": "url('')",
    "background-color": "#0F0F0F",
    "padding": "120px 20px 120px 20px"
  },
  "position": "center",
  "headingsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center"
  },
  "headingsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "headingsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "headings": [
    {
      "styleProps": {
        "font-size": "4.5rem",
        "line-height": "1",
        "padding": "20px 0px 40px 0px",
        "font-weight": "600",
        "color": "#ffffff",
        "font-family-cust": "",
        "font-family": "'Lato', sans-serif",
        "margin": "0px 0px 0px 0px",
        "font-family-bk": "'Lato', sans-serif"
      },
      "stylePropsTab": {
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "padding": "20px 0px 20px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "padding": "20px 0px 20px 0px"
      },
      "text": "Transforming Businesses with Innovative Software Solutions."
    },
    {
      "text": "Check out some of our notable projects and success stories. From startups to enterprises, we've helped numerous organizations achieve their goals.",
      "styleProps": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "color": "#999999",
        "margin": "0px 0px 60px 0px"
      }
    }
  ],
  "dynamicText": {
    "styleProps": {
      "font-size": "1.875rem",
      "line-height": "2.25rem",
      "padding": "10px 0px 10px 0px",
      "text-align": "center"
    },
    "stylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "stylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "strings": []
  },
  "descriptionsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center"
  },
  "descriptionsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptionsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptions": [],
  "buttonsStyleProps": {},
  "buttons": [
    {
      "text": "Get Started",
      "styleProps": {
        "color": "#333333",
        "border-color": "#3b82f680",
        "background-color": "#ffffff",
        "border-width": "0px",
        "border-radius": "9999px"
      },
      "href": "#",
      "openType": "sametab"
    },
    {
      "text": "Learn more  ➜",
      "styleProps": {
        "color": "#ffffff",
        "border-color": "#3b82f680",
        "border-width": "0px"
      },
      "href": "#",
      "openType": "sametab"
    }
  ],
  "emailSecStyleProps": {},
  "subscription": {
    "showSection": "hide",
    "display": "enable",
    "subConfigs": {
      "configType": "convertkit",
      "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
      "configPlaceholder": ""
    },
    "email_placeholder": {
      "text": "example@mail.com"
    },
    "buttonText": {
      "text": "Subscribe",
      "styleProps": {
        "background-color": "#1b1b31",
        "color": "#ffffff"
      }
    },
    "successMessage": {
      "text": "Thank you for the signup",
      "styleProps": {}
    },
    "errorMessage": {
      "text": "Something went wrong. Please try again.",
      "styleProps": {}
    }
  },
  "textsStyleProps": {
    "text-align": "center"
  },
  "texts": [],
  "editFormName": "HEADER_FORM_01",
  "metaDataId": 1745673482496,
  "afterIndex": -1,
  "blockId": 1745673482496,
  "textBlock": {
    "descriptions": [
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      },
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      }
    ],
    "headings": [
      {},
      {}
    ]
  },
  "fonts": {
    "headings": [
      ""
    ]
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "containerStyleProps": {
    "max-width": "1152px"
  },
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  }
}